import React from 'react'
import PropTypes from 'prop-types'

class PageTitle extends React.Component {
  static propTypes = {
    title: PropTypes.string,
  }

  static defaultProps = {
    title: null,
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  update() {
    const { title } = this.props
    if (title) {
      document.title = title
    }
  }

  render() {
    return (null)
  }
}

export default PageTitle
